import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import { events } from "@/mocks/events";

export default function FeaturedEvents() {
  const [lead, ...rest] = events;

  return (
    <section className="w-full bg-background-100/50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            eyebrow="Hot cases"
            title="热门事件推荐"
            description="近期讨论度最高、素材最全的几个事件，已经把证据按时间线排好。"
          />
          <Link
            to="/events"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            查看全部档案
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5">
          <EventCard event={lead} variant="featured" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {rest.slice(0, 2).map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}